@if (isLoaded) {
  @if (gridData.length > 0) {
    <ppl-list-table
      [disableSort]="true"
      [disableSearch]="true"
      [enableActions]="false"
      [data]="gridData"
      [disableSelection]="true"
      [cols]="cols"
      [gridTitle]="false"
      [pagination]="false"
      [loadPage]="true">
    </ppl-list-table>
  } @else {
    <nz-row>
      <p>No Data found</p>
    </nz-row>
  }
}
